import { faUserCircle } from "@fortawesome/free-solid-svg-icons/faUserCircle";
import React from "react";
import styled from "styled-components";

import { AtiraIcon } from "../../../components/AtiraIcon";
import { Flex } from "../../../components/Flex";
import { ImageCreateEdit } from "../../../components/ImageCreateEdit";
import { Text } from "../../../components/Text";
import { TeamRole } from "../../../model/permissions/types/TeamRole.enum";
import { useAppSelector } from "../../../redux/store";
import { userSliceSelectors } from "../../../redux/user/user.selector";
import { TestIDs } from "../../../tests/types/testIds";
import { Rounded } from "../../../theme/Rounded";
import { Spacing } from "../../../theme/Spacing";
import { TeamRoleBadge } from "./TeamRoleBadge";

const Container = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  padding: ${Spacing.s};
  border-radius: ${Rounded.md};
  width: 100%;
`;

const InfoWrapper = styled(Flex)`
  align-items: center;
  gap: ${Spacing.m};
`;

const ImageWrapper = styled(Flex)`
  height: 3rem;
  width: 3rem;
  border-radius: ${Rounded.circle};
  overflow: hidden;
  border: ${({ theme }) => `2px solid ${theme.main}`};
`;

const IconWrapper = styled.div`
  .svg-inline--fa {
    width: 100%;
    height: 100%;
    color: ${({ theme }) => theme.main};
    font-size: 5rem;
  }
`;

export const OwnerRow: React.FC = () => {
  const user = useAppSelector(userSliceSelectors.selectLoggedInUser)!;

  return (
    <Container data-testid={TestIDs.permissions.teamRole.ownerRow}>
      <InfoWrapper>
        <ImageWrapper>
          {user.picture ? (
            <ImageCreateEdit src={user.picture} />
          ) : (
            <IconWrapper>
              <AtiraIcon icon={faUserCircle} />
            </IconWrapper>
          )}
        </ImageWrapper>

        <Flex justifyContent="center" alignItems="center" gap="s">
          <Text>{user.name}</Text>
          <Text fontSize="s">({user.email})</Text>
          <TeamRoleBadge
            role={TeamRole.OWNER}
            dataTestId={TestIDs.permissions.teamRole.ownerBadge}
          />
        </Flex>
      </InfoWrapper>
    </Container>
  );
};
